const Role={
    engineer:"engineer",
    operation:"operation",
    enterprise:"enterprise",
    enterpriseOps:"enterprise-ops"
}
export default Role